/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */

// Lib imports
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {}

export const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  missing,
  silentTranslationWarn: true
})

const newLangItems = []
const loadedLanguages = []
export var loadingCompleted = false

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  loadingCompleted = true

  return lang
}

export function missing (locale, key, instance) {
  // still loading lang texts
  if (!loadingCompleted) return key

  // to avoid recurring calls
  // -----------------------------------------
  if (newLangItems.includes(key)) return key
  newLangItems.push(key)
  // -----------------------------------------

  // instance.Maglink.PostLanguage(1, key).then((resp) => { })
  Vue.prototype.Maglink.PostLanguage(1, key).then((resp) => { })

  return key
}

export function loadLanguageAsync (lang, instance) {
  if (!loadedLanguages.includes(lang)) {
    return instance.Maglink.GetLanguage(lang)
      .then((resp) => {
        i18n.setLocaleMessage(lang, resp.data)
        loadedLanguages.push(lang)
        return setI18nLanguage(lang)
      })
  } else {
    if (i18n.locale !== lang) {
      return Promise.resolve(setI18nLanguage(lang))
    } else {
      loadingCompleted = true

      return Promise.resolve(lang)
    }
  }
}
